import Table from '@/common/components/Table'
import { useFilterParams } from '@/common/hooks/useFilterParams'
import { Mapper } from '@/common/services/mapper'
import { lastUsageDeclarationPerCategoryTableColumns } from '@/features/equipments/constants/lastUsageDeclarationsPerCategoryTableColumns.constant';
import { useEquipmentLastUsageDeclarationsPerCategory } from '@/features/equipments/hooks/useEquipmentLastUsageDeclarationsPerCategory';
import { EquipmentLastUsageDeclarationsPerCategoryTransformer } from '@/features/equipments/services/equipmentLastUsageDeclarationsPerCategoryTransformer';
import { EquipmentData } from '@/features/equipments/types/equipments.type';
import { useParams } from 'react-router-dom'

interface EquipmentLastUsageDeclarationsPerCategoryProps {
  equipment?: EquipmentData;
}

export const EquipmentLastUsageDeclarationsPerCategory = ({ equipment }: EquipmentLastUsageDeclarationsPerCategoryProps) => {
  const { id: equipmentId } = useParams()

  const { filterParams, setFilterParams } = useFilterParams();

  const {
    data: equipmentLastUsageDeclarationsPerCategory,
    meta: equipmentLastUsageDeclarationsPerCategoryMeta,
    isPending: equipmentLastUsageDeclarationsPerCategoryIsPending,
  } = useEquipmentLastUsageDeclarationsPerCategory({
    equipmentId,
    filters: {
      page: filterParams.page || 1,
    },
    mapper: Mapper.mapWithTransformer({
      transformer: EquipmentLastUsageDeclarationsPerCategoryTransformer.tableTransformer(equipment),
    }),
  })

  return (
    <div className="flex flex-col gap-6">
      <Table
        className="max-h-[calc(100vh-192px)]"
        columns={lastUsageDeclarationPerCategoryTableColumns}
        isLoadingData={equipmentLastUsageDeclarationsPerCategoryIsPending}
        rows={equipmentLastUsageDeclarationsPerCategory}
        rowEmptyValue="--"
        page={filterParams.page || 1}
        setPage={(page) => setFilterParams((prev) => ({ ...prev, page }))}
        totalPages={equipmentLastUsageDeclarationsPerCategoryMeta.total_pages}
        totalCount={equipmentLastUsageDeclarationsPerCategoryMeta.total}
      />
    </div>
  )
}
